window.addEventListener("turbo:load", init_global_js);
window.addEventListener("turbo:frame-load", init_global_js);

/* Main function to call all initializers */
export function init_global_js(event) {
  const html= (event.currentTarget) ? event.currentTarget.document : event
  init_autosubmit(html);
}


function init_autosubmit(doc= document) {
  /* Submit form when Enter given on a Select input element (search filter form) */
  const selectElements= doc.querySelectorAll('form select:not([data-auto-submit="true"])');
  selectElements.forEach( (elm) => {
    elm.addEventListener('keypress', (event) => {
      if (event.which==13) {
        event.target.form.requestSubmit();
      }      
    })
  })

  /* Submit form directly on changing one of the input fields */
  const autoSubmitElements= doc.querySelectorAll("form [data-auto-submit='true'], form[data-auto-submit='true']");
  autoSubmitElements.forEach((elm) => {
    elm.addEventListener('change', function(event) {
      /* Submit this form using TurboStreams */
      event.target.form.requestSubmit();
    })
  })

}
